import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query, limit } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { SalesWinLossDigest } from '../utils/salesWinLossAnalytics';

export function useSalesWinLossDigests(max = 30) {
  const [digests, setDigests] = useState<SalesWinLossDigest[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'salesWinLossDigests'), orderBy('report_date', 'desc'), limit(max));
    const unsub = onSnapshot(
      q,
      snap => {
        setDigests(
          snap.docs.map(d => ({
            id: d.id,
            report_date: d.id,
            ...(d.data() as Omit<SalesWinLossDigest, 'id' | 'report_date'>),
          })),
        );
        setLoading(false);
      },
      () => setLoading(false),
    );
    return () => unsub();
  }, [max]);

  const latestDigest = digests[0] || null;
  return { digests, latestDigest, loading };
}
